<template>
  <div class="relative">
    <div class="relative">
      <input
        v-model="searchedText"
        type="text"
        autocomplete="off"
        class="search-input"
        :id="id"
        :name="id"
        :class="(inputWidthHeightClass, borderClass)"
        placeholder="placeholder"
        @focus="showSuggestion"
        @blur="exit"
        @input="searchItemHandler"
      />
      <label :for="id" class="label-ease input-type-ease bg-secondary">
        {{ placeHolder }}
      </label>
      <search-icon v-if="isFocused" class="prepend-icon" />
    </div>
    <transition name="slide-suggestion">
      <div class="wrapper-suggestion" v-if="isFocused">
        <p
          class="suggestion-item"
          v-for="(filteredItem, index) in filteredItems"
          :key="index"
          @mousedown="selectedSuggest(filteredItem)"
        >
          {{ filteredItem.name }}
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import SearchIcon from '@/assets/icons/vue/search_normal.vue';

export default {
  name: 'BaseSelectSearchable',
  components: { SearchIcon },
  props: {
    options: {
      type: Array,
      default: null,
    },
    id: {
      type: String,
      required: true,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: 'full',
    },
    height: {
      type: String,
      default: '68',
    },
    radius: {
      type: String,
      default: 'sm',
    },
    default: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
  },
  data() {
    return {
      isFocused: false,
      searchedText: '',
      filteredSearchItems: '',
      selected: {},
    };
  },
  mounted() {
    if (this.default.name) {
      this.searchedText = this.default.name;
      this.selected = this.default;
    }
    this.$emit('searched', this.searchedText);
  },
  watch: {
    default() {
      this.searchedText = this.default.name;
      this.selected = this.default;
    },
  },
  computed: {
    borderClass() {
      return {
        rounded: this.radius === 'default',

        'rounded-sm': this.radius === 'sm',
      };
    },
    filteredItems() {
      if (this.searchedText) {
        return this.options.filter(
          (item) => item.name.toLowerCase().indexOf(this.searchedText.toLowerCase()) > -1,
        );
      }
        return this.options;
    },
    inputWidthHeightClass() {
      return `w-${this.width} h-${this.height}`;
    },
  },
  methods: {
    showSuggestion() {
      this.isFocused = true;
    },
    searchItemHandler() {
      this.options.filter((item) => this.searchedText === item);
    },
    exit() {
      this.isFocused = false;
    },
    selectedSuggest(searchItem) {
      this.selected = searchItem;
      this.isFocused = false;
      this.searchedText = this.selected.name;
      this.$emit('selectedItem', this.selected);
    },
  },
};
</script>
<style lang="css" scoped>
/* START TRANSITION */
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
.slide-suggestion-enter-active,
.slide-suggestion-leave-active {
  @apply transform transition duration-500 ease-custom;
}
.slide-suggestion-enter,
.slide-suggestion-leave-to {
  @apply -translate-y-1/2 scale-y-0  opacity-0;
}
.slide-suggestion-enter-to,
.slide-suggestion-leave {
  @apply translate-y-0 scale-y-100  opacity-100;
}
/* END TRANSITION */
input::placeholder {
  @apply font-semibold top-13 p-5 text-subtitle;
}
input[placeholder] {
  @apply focus:pl-26;
}
input[placeholder]:is(:lang(fa), :lang(ar)) {
  @apply focus:pr-26;
}
.wrapper-suggestion {
  @apply absolute bg-tertiary w-full border-t border-default
  border-opacity-20 rounded-b p-2 h-167 overflow-y-scroll overflow-x-hidden z-20;
}
.suggestion-item {
  @apply grid grid-flow-col auto-cols-max gap-4 place-items-center p-2 w-full
  rounded text-12 cursor-pointer transition duration-300 hover:bg-secondary;
}
.prepend-icon {
  @apply absolute top-1/3 left-1.5;
}
.append-icon {
  @apply absolute top-18 right-4 hover:cursor-pointer;
}
.search-input {
  @apply border border-default bg-secondary
  block py-12 w-full px-2 text-18 text-subtitle outline-none
   transition-all duration-500 focus:rounded-b-none focus:bg-secondary;
}
.loading {
  @apply text-center absolute top-1/2 right-1/2
  transform translate-x-1/2 -translate-y-1/2;
}
input::placeholder {
  @apply opacity-0;
}
.label-ease {
  @apply text-18 font-normal absolute px-5 py-5 mx-5 text-subtitle
      transition-all ease-in-out duration-300 top-/21;
}
input:focus ~ label.input-type-ease,
input:not(:placeholder-shown) ~ label.input-type-ease {
 display: none;
}
</style>
